import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/auth/service';

@Component({
  selector: 'app-header-enterprise',
  templateUrl: './header-enterprise.component.html',
  styleUrls: ['./header-enterprise.component.scss']
})
export class HeaderEnterpriseComponent implements OnInit {

  constructor(public authService: AuthenticationService, private router : Router) { }

  ngOnInit(): void {
    
  }

  logout() {
    localStorage.clear();
    setTimeout(() => {
      location.href = "https://login.microsoftonline.com/common/oauth2/v2.0/logout";
    }, 500);
  }
  
  gerenciar() {
    //const closeWatson = parent['closeWatson']
    //if(typeof closeWatson === "function"){
    //  closeWatson();
    //}
    this.router.navigateByUrl("/admin/home")
  }
  
}
